module.exports = __webpack_public_path__ + "img/setting.e5407825.svg";